import EventActionProto from '../event-action-proto';

class TodoListTemplateNew extends EventActionProto {

    constructor(uid, data) {
        super(uid, data, false);
    }

    process() {

        if (!gd.session._todoListTemplates.get(this.data['id'])) {
            gd.session._todoListTemplates.add([this.data],{parse:true});
        } else {
            console.error("not meant to happen...");
        }

        // super.process();
    }
}

module.exports = TodoListTemplateNew;


